// extracted by mini-css-extract-plugin
export default {"inActive":"block-external-users_inActive__ynt-t"};